import { createFileRoute } from '@tanstack/react-router'

import { MeetingPollPage } from '@/components/meetings/meeting-poll-page'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/meeting-polls/$shortId')({
  validateSearch: (search: Record<string, unknown>) => readSearch(RETURN_SHAPE, search),
  component: MeetingPollRoutePage,
})

function MeetingPollRoutePage() {
  const { shortId } = Route.useParams()
  return <MeetingPollPage key={shortId} shortId={shortId} />
}
